<template>
  <b-row class="invoice-add">
    <b-card class="article-sidebar" style="width:20%">
      <div class="article-sidebar-list">

        <b-card-title class="mb-2 hover" v-for="item in articleList" :key="item.id" @click="changeDetail(item.id)">
          {{ item.title || '' }}
        </b-card-title>

      </div>
    </b-card>
    <b-card class="d-flex align-items-center justify-content-center" style="width:78%;margin-left: 20px">
      <div class="text-center">
        <b-card-title class="mb-2">{{ article.title }}</b-card-title>
        <p class="mb-1">
          <b-badge variant="secondary">{{ article.cate ? article.cate.title : '' }}</b-badge>
        </p>
        <p class="mb-0">{{ article.created_at || '' }}</p>
      </div>
      <!--      <b-img v-if="article.cover" :src="article.cover" fluid alt="封面图"-->
<!--             class="rounded-0"-->
<!--      ></b-img>-->
      <b-card-body>
        <b-card-text class="mt-4" v-html="article.content||''">
        </b-card-text>
      </b-card-body>
    </b-card>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BImg,
  BCardBody,
  BBadge,
} from 'bootstrap-vue'
import ContentWithSidebar from '@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import axiosIns from '@/libs/axios'
import {
  ALL_CATEGORY_ID,
  LEGACY_ALL_CATEGORY_ID,
  filterBrochureArticles,
  filterBrochureCategories,
} from './brochuresHelpers'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BImg,
    BCardBody,
    BBadge,
    ContentWithSidebar,
  },
  data() {
    return {
      faqSearchQuery: '',
      cate_id: 0,
      id: '',
      articleList: [],
      article: {},
    }
  },
  created() {
    if (this.$route.query.cate_id) {
      this.cate_id = this.$route.query.cate_id
    }
    if (this.$route.query.title) {
      this.faqSearchQuery = this.$route.query.title
    }

    this.id = this.$route.query.id
    this.fetchDetails()
  },
  methods: {
    filterArticles(list, categoryIds) {
      return filterBrochureArticles(list, categoryIds)
    },
    async fetchDetails() {
      const title = this.faqSearchQuery
      const pageSize = 10000
      let cateId = Number(this.cate_id)
      if (cateId === LEGACY_ALL_CATEGORY_ID) {
        cateId = ALL_CATEGORY_ID
      }

      const cateRes = await axiosIns.get('/article/getArticleCateList', { params: { pageSize: 1000 } })
      const categoryIds = filterBrochureCategories(cateRes.data.list).map(item => item.id)

      if (cateId === ALL_CATEGORY_ID) {
        if (!categoryIds.length) {
          this.articleList = []
          return
        }

        const results = await Promise.all(
          categoryIds.map(id =>
            axiosIns.get('/article/list', { params: { cate_id: id, title, pageSize } })
          )
        )
        const merged = []
        const seen = new Set()
        results.forEach(res => {
          this.filterArticles(res.data?.list, categoryIds).forEach(item => {
            if (!seen.has(item.id)) {
              seen.add(item.id)
              merged.push(item)
            }
          })
        })
        this.articleList = merged
      } else {
        const res = await axiosIns.get('/article/list', { params: { cate_id: this.cate_id, title, pageSize } })
        this.articleList = this.filterArticles(res.data?.list, categoryIds)
      }

      const current = this.articleList.find(item => item.id == this.id)
      if (current) {
        this.article = current
      }
    },
    changeDetail(id) {
      this.id = id
      const current = this.articleList.find(item => item.id == id)
      if (current) {
        this.article = current
      }
    }
  },
}
</script>

<style lang="scss">
.hover:hover {
  color: #445f79;
  cursor: pointer;
}

.article-sidebar-list {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
